/**
 * Orders tab — collapsible order sections from parsed clinical orders.
 */
import { FC } from 'react'
import type { PatientPanelData } from '../types'
import { CollapsibleOrderSection } from '../shared/CollapsibleOrderSection'
import { PanelSkeleton } from '../shared/PanelSkeleton'

export const OrdersTab: FC<{ data: PatientPanelData }> = ({ data }) => {
  const hasSections = data.orders?.sections && data.orders.sections.length > 0

  // Loading state
  if (data.isGenerating && !hasSections) {
    return (
      <div className="flex-1 overflow-y-auto custom-scrollbar p-3">
        <PanelSkeleton lines={6} />
      </div>
    )
  }

  // Empty state
  if (!hasSections) {
    return (
      <div className="flex-1 overflow-y-auto custom-scrollbar p-3 flex items-center justify-center">
        <p className="text-xs text-muted-foreground opacity-40">
          No orders data available
        </p>
      </div>
    )
  }

  return (
    <div className="flex-1 overflow-y-auto custom-scrollbar p-3 space-y-1.5">
      {data.isGenerating && (
        <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg px-3 py-2 animate-pulse">
          <p className="text-xs font-medium text-primary">
            Agents still working — orders may update
          </p>
        </div>
      )}
      {data.orders!.sections.map((section, i) => (
        <CollapsibleOrderSection
          key={i}
          title={section.title}
          items={section.items}
          defaultOpen={i < 3}
        />
      ))}
    </div>
  )
}
